<template>
  <b-table id="pk-table" striped fixed small responsive="sm" :items="items" :fields="fields">
    <template #cell(value)="{ item }">
      {{ item.value }} <span v-if="item.sd">&plusmn; {{ item.sd }}</span>
    </template>
    <template #cell(unit)="{ item }"><span v-html="displaySIUnits(item.unit)"></span></template>
  </b-table>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { displaySIUnits } from '@/models/utils/constants';
import { useDosingStore } from '@/stores/dosing';

defineOptions({ name: 'PkParams' });

const store = useDosingStore();

const fields = [
  { key: 'label', sortable: true },
  { key: 'type', sortable: true },
  { key: 'value', sortable: true },
  { key: 'unit', sortable: true },
];

const items = computed(() => {
  const sim = store.getSimulation;
  return sim ? sim.pkParamModel.pkParams : [];
});
</script>

<style scoped></style>
